/**
 * Utility fragments every interactive component shares. They are written out as whole strings so
 * Tailwind's source scanner finds them (a class name assembled at run time would never be emitted).
 */

/**
 * Visible focus indicator (WCAG 2.2 AA, 2.4.11 / 2.4.13): a two-pixel ring in the `focusRing` role,
 * drawn outside the control so it keeps its contrast on any surface. An ancestor with `overflow`
 * other than `visible` still clips it, so a text field, which tends to fill such a container from
 * edge to edge, draws its ring inside the box instead (`-outline-offset-2`, see `Input`).
 */
export const FOCUS_RING =
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus-ring';

/**
 * Smallest target for a control that sits next to other controls: 24 px everywhere (WCAG 2.2 AA,
 * 2.5.8) and 44 px where the pointer is coarse (Apple HIG, WCAG 2.5.5 AAA).
 */
export const TOUCH_TARGET = 'min-h-6 min-w-6 pointer-coarse:min-h-11 pointer-coarse:min-w-11';

/** How a control looks while it is disabled; the reason is always conveyed elsewhere too. */
export const DISABLED = 'disabled:cursor-not-allowed disabled:opacity-50';

/** The same, for elements that carry `aria-disabled` because they cannot carry `disabled`. */
export const ARIA_DISABLED =
  'aria-disabled:cursor-not-allowed aria-disabled:opacity-50 aria-disabled:pointer-events-none';

/** A floating layer: menu, tooltip, popover, dialog. */
export const SURFACE_OVERLAY =
  'bg-surface-elevated text-text border border-border shadow-md rounded-md';

/** Colour transition that stops when the reader asked for less motion. */
export const MOTION_COLORS = 'motion-safe:transition-colors';
